// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"c6d5ac26","686":"d6f23e3f","746":"13127dad","858":"abc953eb"}[chunkId] + ".chunk.js";
};